const updates = [
  {
    date: '2026-07-30',
    title: '久久视频站点入口更新完成',
    desc: '久久视频在线视频网站最新可用入口已更新至平台，视频播放器在线看视频体验优化。',
    tag: '站点更新',
  },
  {
    date: '2026-07-28',
    title: '芒果视频资源专区新增推荐',
    desc: '芒果视频在线视频网站精品资源推荐列表更新，新增多部热门视频播放器在线看视频内容。',
    tag: '资源更新',
  },
  {
    date: '2026-07-25',
    title: '97视频新增备用访问通道',
    desc: '97视频平台备用访问方式更新上线，保障视频播放器在线看视频的连续稳定体验。',
    tag: '站点更新',
  },
  {
    date: '2026-07-22',
    title: '丝瓜视频站点状态巡检完成',
    desc: '丝瓜视频在线视频网站例行状态巡检完成，所有视频资源入口运行正常，在线看视频功能稳定。',
    tag: '巡检报告',
  },
  {
    date: '2026-07-19',
    title: '蓝莓视频新域名入口已收录',
    desc: '蓝莓视频最新域名入口已添加至国产91视频平台，用户可通过本站直达视频播放器在线看视频。',
    tag: '站点更新',
  },
  {
    date: '2026-07-16',
    title: '平台移动端适配全面优化',
    desc: '国产91视频移动端访问性能优化完成，手机浏览器使用视频播放器在线看视频更加流畅。',
    tag: '平台优化',
  },
  {
    date: '2026-07-12',
    title: '视频资源导航数据刷新完毕',
    desc: '平台全量视频资源站点数据刷新完成，久久视频、芒果视频等在线视频网站入口精确度提升。',
    tag: '数据刷新',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-lg mx-auto">
          国产91视频平台运营动态，久久视频、芒果视频等在线视频网站资源更新快讯
        </p>
        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-200"></div>
          <div className="space-y-8">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-6 pl-12">
                <div className="absolute left-0 w-[38px] h-[38px] rounded-full bg-primary-100 border-2 border-primary-200 flex items-center justify-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl border border-background-200/70 p-5 hover:border-primary-200/60 transition-all cursor-pointer">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className="inline-block px-2.5 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  </div>
                  <h3 className="text-base font-bold text-foreground-800 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}